/**
 * @generated SignedSource<<ab72ad45e1fe928d105cdf7cbcbaf253>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateLikeInput = {
  clientMutationId?: string | null | undefined;
  like: LikeInput;
};
export type LikeInput = {
  toUserId: any;
};
export type useLikeMutation$variables = {
  input: CreateLikeInput;
};
export type useLikeMutation$data = {
  readonly createLike: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type useLikeMutation = {
  response: useLikeMutation$data;
  variables: useLikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateLikePayload",
    "kind": "LinkedField",
    "name": "createLike",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useLikeMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useLikeMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "fc4314b25c0b390fff2e3cf0eff05ece",
    "id": null,
    "metadata": {},
    "name": "useLikeMutation",
    "operationKind": "mutation",
    "text": "mutation useLikeMutation(\n  $input: CreateLikeInput!\n) {\n  createLike(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d977c863fddfc4a7d8887a5d1e11b64";

export default node;
